/**
 * Application Form
 * @author PBirudukota
 */
import {Component, OnInit,ViewChild, ElementRef, HostListener} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MessagesService} from '../../services/messages.service';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {LookupService} from '../../services/lookup.service';
import {CustomerFormService} from '../../services/customer-form.service';
import {ClrLoadingState} from '@clr/angular';
import {forkJoin, Observable, concat} from 'rxjs';
import {ReviewComponent} from  '../review/review.component';
import {ReCaptcha2Component, NgxCaptchaModule} from 'ngx-captcha';
import {
  BUSINESS_TYPES,
  FILE_SIZE_LIMIT,
  FILE_FORMATS_ALLOWED,
  FILE_SIZE_ERROR,
  FILE_FORMAT_ERROR,
  FILE_LIMIT_ERROR
} from '../../shared/constants.util';
import {REGEX} from '../../shared/regex.util';
import {taxStates,docExemptStates} from '../../shared/tax.json';

@Component({
  selector: 'app-application-form',
  templateUrl: './application-form.component.html',
  styleUrls: ['./application-form.component.css'],
  providers: [NgxCaptchaModule, ReviewComponent]
})
export class ApplicationFormComponent implements OnInit {
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;


  constructor(private route: ActivatedRoute,
              private messagesService: MessagesService,
              private lookupService: LookupService,
              private customerService: CustomerFormService,
              private router: Router,
              private review: ReviewComponent) {
    this.messagesService.sendBGMessage('no');
    // This should be enabled to switch between ATD and NTD
    // this.currentDivision = this.route.snapshot.params['division'];
    console.log(`Current Division is : ${this.currentDivision}`);
    // TODO This should switch based on Division
    this.currentDivision = 'atd';
    this.currentCountry = 'US';
    this.mySQLOrgId = 82;
    this.phoneCountryCode = '1';
    this.businessTypes = BUSINESS_TYPES;
    this.messagesService.sendLogoMessage(this.currentDivision);
    this.initializeStates(this.currentCountry);
    this.initializeBusinessStructures(this.currentDivision === 'atd' ? 0 : 0);
    this.customerStatus();

  }

  customerApplicationForm: FormGroup;
  PROSPECT_ADDRESS: FormArray;
  PROSPECT_REFERENCE: FormArray;
  PROSPECT_CONTACT: FormArray;
  // Defaulting it to ATD for Phase - 1
  currentDivision = 'atd';
  // TODO Should Revisit this code
  countiesApplicant: Array<any>;
  countiesShipping: Array<any>;
  customerNumber: number;
  countiesRefOne: Array<any>;
  countiesRefTwo: Array<any>;
  countiesPG: Array<any>;
  states: Array<any>;
  businessStructures: Array<any>;
  businessTypes: Array<string>;
  validateBtnState: ClrLoadingState = ClrLoadingState.DEFAULT;
  mySQLOrgId: number;
  phoneCountryCode: string;
  currentCountry: string;
  toggleCreditApplication: string;
  togglePersonalGuaranty : string;
  showTC = false;
  showError = false;
  errorMessage: string;
  guarantorDocB64: any;
  blcDocB64: any;
  guarantorDocLabel: string;
  blcDocLabel: string;
  guarantorDoc: any;
  blcDoc: any;
  docError = false;
  guarantorDocObject: object = {};
  blcDocObject: object = {};
  blcFileErrorMessage: string;
  pgErrorMessage: string;
  stateTaxFilesLabels: Array<string> = [];
  stateTaxFilesError: string;
  stateTaxFiles: Array<any> = [];
  stateTaxFilesObjects: Array<any> = [];
  phonetype: string;
  phonetypes = [];
  resetCredit: string;
  currentDate: string = new Date().toLocaleDateString();
  customer = this.customer;
  st=true;
  reviewState: string;
  creditApp: string;
  apRemoveControl: string = "Y";
  guarantorRemoveControl: string = "Y";
  county: string;
  newState = [];
  newCounty= [];
  starter: string;
  UpdatedDbaName:any;
  enableMjf : any;
  applicantState: any;
  toggleBillAddress: any;
  requiredDocuments: any;
  requiredDocNote: any;
  enableRequiredDocNote: string = 'N';
  taxDocsEnable: any;
  taxExemptNote: any;
  mjfType: any;
  mjfval: any;
  addressState: boolean = false;
  addressCounty: boolean = false;
  typeOfBusiness: boolean = false;
  phoneLineType: boolean = false;
  phoneLineTypeTwo: boolean = false;
  billingAddressState: boolean = false;
  billingAddressCounty:boolean = false;
  principalAddressState:boolean = false;
  principalAddressCounty: boolean = false;
  principalAddressTwoState: boolean = false;
  principalAddressTwoCounty: boolean = false;
  taxableItemsError: boolean = false;
  propertyDescriptionError:boolean = false;
  invalidControls = [];
  basic: boolean;
  creditValue: any;
  annualPurachaseValue: any;
  differentTypeOfBusiness: Array<string> = ['TIRE DEALER | SERVICE STATION','NEW CAR DEALER','GOVERNMENT'];
  // public readonly siteKey = '6LdHn5sUAAAAAECrwsqUGbWrO2_y1NheVlXXVjvv';
  // public captchaIsLoaded = false;
  // public captchaSuccess = false;
  // public captchaIsExpired = false;
  // public captchaResponse?: string;
  

  private static fileSanityCheck(files: any, allowMultiple: boolean): boolean {

    let result = false;

    // Check No. of Files
    if ((allowMultiple && files.length > 2) || (!allowMultiple && files.length > 1)) {
      return false;
    }

    // Check File(s) Format
    for (const file of files) {
      result = FILE_FORMATS_ALLOWED.includes(file.type);
      if (!result) {
        return result;
      }
    }

    // Check File(s) Size
    for (const file of files) {
      result = file.size < FILE_SIZE_LIMIT;
      if (!result) {
        return result;
      }
    }

    return result;

  }


  ngOnInit() {
    
    this.phonetypes = ['Telephone','Mobile'];

    if(this.customer === 'newcustomer'){

      this.initializeCustomer();

      this.initializeValidators();

        this.messagesService.getReviewData().subscribe((
          res => {

            if(res !== ""){
              
              let obj = res['value'];
  
              this.customerApplicationForm.patchValue(obj);

             let ApplicantState = this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('STATE')['value'];
             let ShippingState = this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('STATE')['value'];
             let PrincipleState = this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].get('STATE')['value'];
             let PrincipleTwoState = this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][3].get('STATE')['value'];
             this.UpdatedDbaName = this.customerApplicationForm.controls['DBA_NAME']['value'];
             this.applicantState = ApplicantState.split('@')[0];
             // Property Description
             this.propertyDescription(this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].value,this.applicantState);
             this.fixAnnualPurchaseValue(this.customerApplicationForm.controls['EST_ANNUAL_PUR_VOL'].value);
             this.setToTwoDecimals(this.customerApplicationForm.controls['CREDIT_LIMIT_REQUESTED'].value);
  
             if(PrincipleState && PrincipleTwoState !== null){
              this.initializeCounties(PrincipleState.split('@')[0],'refOne');
              this.initializeCounties(PrincipleTwoState.split('@')[0],'refTwo');

             }

             if(ApplicantState !== null){

              this.initializeCounties(ApplicantState.split('@')[0],'applicant');

             }


             if(ShippingState !== null){

              this.initializeCounties(ShippingState.split('@')[0],'shipping');

             }            
            }

          }
        ));

    }

    //Restore Documents data from Preview
    this.messagesService.getDocData().subscribe((res => {

      if(res !== ""){

      this.blcDoc = res['blc'];
      this.guarantorDoc = res['pg'];
      this.stateTaxFiles = res['state'];
      this.blcDocLabel = res['blcDocLabel'];
      this.guarantorDocLabel =res['guarantorDocLabel'];
       this.stateTaxFilesLabels = res['stateTaxFilesLabels'];
       this.enableMjf = res['enableMjf'];
       this.toggleBillAddress = res['enableShipping'];
       this.requiredDocuments = res['requiredDocs'];
       this.taxDocsEnable = res['enableTaxDocs'];
       this.mjfType = res['mjfType'];
       this.mjfval = res['mjfval'];
       this.taxExemptNote = res['taxExemptNote'];
       this.enableRequiredDocNote = res['enableRequiredDocNote'];

     //Restoring MJF data from Preview
      this.buildMjf(this.applicantState , this.mjfType, this.mjfval);

       //Restore Validation data from Preview
      this.messagesService.getValidationData().subscribe((
        resp => {

          console.log('at review state res', resp);
  
          this.reviewState = resp['reviewState'];

          if(this.reviewState === 'Y'){
            this.resetCreditApplication(this.reviewState);

          }
        }
      ));
      }


    }));
    

    
  }

  //Verify Business date should not be greater than future date

  dateVerify(value: any) {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    let enteredDate = new Date(value);
    enteredDate.setDate(enteredDate.getDate());
    if (enteredDate > currentDate) {
     this.customerApplicationForm.controls['DATE_BUSINESS_OPENED'].setErrors({ 'Invalid': true });
    }
  }


  valueIsSelect(type:any, value: any){
    switch(type + " "+ value){
      case ('address Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('STATE').setErrors({ 'Invalid': true });
        this.addressState = true;
      break;
      case ('addressCounty Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('COUNTY').setErrors({ 'Invalid': true });
        this.addressCounty = true;
      break;
      case ('billingAddress Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('STATE').setErrors({ 'Invalid': true });
        this.billingAddressState = true;
      break;
      case ('billingAddressCounty Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('COUNTY').setErrors({ 'Invalid': true });
        this.billingAddressCounty = true;
      break;
      case ('principalAddress Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].get('STATE').setErrors({ 'Invalid': true });
        this.principalAddressState = true;
      break;
      case ('principalAddressCounty Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].get('COUNTY').setErrors({ 'Invalid': true });
        this.principalAddressCounty = true;
      break;
      case ('principalAddressTwo Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][3].get('STATE').setErrors({ 'Invalid': true });
        this.principalAddressTwoState = true;
      break;
      case ('principalAddressTwoCounty Select'):
        this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][3].get('COUNTY').setErrors({ 'Invalid': true });
        this.principalAddressTwoCounty = true;
      break;
      case ('typeOfBusiness Select'):
        this.customerApplicationForm.controls['TYPE_OF_BUSINESS'].setErrors({ 'Invalid': true });
        this.typeOfBusiness = true;
      break;
      case ('phoneLineType Select'):
        this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][2].get('PHONE_LINE_TYPE').setErrors({ 'Invalid': true });
        this.phoneLineType = true;
      break;
      case ('phoneLineTypeTwo Select'):
        this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][8].get('PHONE_LINE_TYPE').setErrors({ 'Invalid': true });
        this.phoneLineTypeTwo = true;
      break;
      default:
        this.addressState = false;
        this.addressCounty = false;
        this.typeOfBusiness = false;
        this.phoneLineType = false;
        this.phoneLineTypeTwo = false;
        this.billingAddressState = false;
        this.billingAddressCounty = false;
        this.principalAddressState = false;
        this.principalAddressCounty = false;
        this.principalAddressTwoState = false;
        this.principalAddressTwoCounty = false;
    }
}

  customerStatus(){
    let check = this.route.queryParams.subscribe(params => {
      this.customer = params['customer'];
    });
}


  initializeCustomer(){

    this.customerApplicationForm = new FormGroup({

      // All these belong to the CUSTOMER_INFO table
      APPLICANT_NAME: new FormControl(null, [Validators.required, Validators.pattern(REGEX.newDBA)]),
      APPLICANT_TITLE: new FormControl(null),
      APPLICANT_COMMENTS: new FormControl(null),
      DBA_NAME: new FormControl(null, [Validators.required, Validators.pattern(REGEX.newDBA)]),
      SOURCE_NAME: new FormControl('ONBOARDING'),
      BUSINESS_TYPE: new FormControl(null),
      STATE_ORG_ID: new FormControl(null, [Validators.required, Validators.pattern(REGEX.NUMBERS)]),
      JGZZ_FISCAL_CODE: new FormControl(null, [Validators.required, Validators.pattern(REGEX.NUMBERS)]),
      DNB_NUMBER: new FormControl(null,[(Validators.pattern(REGEX.DNB_NUM))]),
      YRS_IN_BUSINESS: new FormControl(null, [Validators.pattern(REGEX.NUMBERS)]),
      PO_REQUIRED: new FormControl('N'),
      EST_ANNUAL_PUR_VOL: new FormControl(null, [Validators.pattern(REGEX.USD)]),
      CREDIT_LIMIT_REQUESTED: new FormControl(null, [Validators.pattern(REGEX.USD)]),
      CUSTOMER_CREDIT_AUTHORIZED: new FormControl('N'),
      CUSTOMER_REQUESTED_CREDIT: new FormControl('N'),
      PST_NUM: new FormControl(null),
      TIRE_STEWARDSHIP: new FormControl(null),
      PREMISIS: new FormControl(null),
      RENTAL_PAYMENT: new FormControl(null),
      OWNER_FILED_BANKRUPT: new FormControl(null),
      BANKRUPT_REASON: new FormControl(null),
      TRUSTEE_NAME: new FormControl(null),
      ACCT_REQUESTED: new FormControl(null),
      BSNS_WITH_NTD: new FormControl(null),
      PRVS_BSNS_ACCT_NUM: new FormControl(null),
      TC_DATE: new FormControl(null),
      TAXABLE_ITEMS: new FormControl(null,[Validators.required]),
      TIRE_DISPOSAL_FEE: new FormControl(null),
      TAX_EXEMPTION_NUMBER: new FormControl(null),
      PROPERTY_DESCRIPTION: new FormControl(null, [Validators.required]),
      EMAIL_CORRESPONDENCE: new FormControl(null),
      ATD_CONTACT_PERSON: new FormControl(null),
      ATD_EMP_NUM: new FormControl(null),
      PROCESS_STATUS: new FormControl('PENDING'),
      PREV_ADDRR_LESS_THAN_3YR: new FormControl(null),
      TERMS_CONDITIONS_ACCEPT: new FormControl(null),
      // myRecaptcha : new FormControl(null),
      CUSTOMER_SIGNATURE: new FormControl(null),
      IS_CUST_TAX_EXEMPT: new FormControl('Y'),
      STAGE_CUSTOMER_NUM: new FormControl(null),
      LIVE_CUSTOMER_NUM: new FormControl(null),
      OWNER_FIRST_NAME: new FormControl(null, [Validators.required, Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]),
      OWNER_LAST_NAME: new FormControl(null, [Validators.required, Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]),
      TYPE_OF_BUSINESS: new FormControl(null, [Validators.required]),
      TYPE_OF_BUSINESS_DESC: new FormControl(null, [Validators.required]),
      DATE_BUSINESS_OPENED: new FormControl(null, [Validators.pattern(REGEX.DATE)]),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required),
      PROSPECT_CONTACT: new FormArray([
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'APPLICANT'),
        this.initializeCustomerContact('BUSINESS', 'EMAIL', 'APPLICANT'),
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'OWNER'),
        this.initializeCustomerContact('BUSINESS', 'EMAIL', 'OWNER'),
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'CHECK_WRITER'),
        this.initializeCustomerContact('BUSINESS', 'EMAIL', 'CHECK_WRITER'),
        this.initializeCustomerContact('BUSINESS', 'PHONE', 'CHECK_WRITER'),
        this.initializeCustomerContact('BUSINESS', 'EMAIL', 'CHECK_WRITER'),
      ]),
      PROSPECT_REFERENCE: new FormArray([
        this.initializeCustomerRef('CHECK_WRITER'), 
        this.initializeCustomerRef('CHECK_WRITER'),
      ]),
      PROSPECT_ADDRESS: new FormArray([this.initializeCustomerAddress('SHIP_TO'),
        this.initializeCustomerAddress('BILL_TO'),
        this.initializeCustomerAddress('CHECK_WRITER'),
        this.initializeCustomerAddress('CHECK_WRITER'),
      ])
    });
  }


  /**
   * Build Customer Contact Form Object
   */
  initializeCustomerContact = (CONTACT_POINT_PURPOSE: string, CONTACT_POINT_TYPE: string, CONTACT_TYPE: string) => {
    return new FormGroup({
      CONTACT_POINT_PURPOSE: new FormControl(CONTACT_POINT_PURPOSE),
      CONTACT_POINT_TYPE: new FormControl(CONTACT_POINT_TYPE),
      CONTACT_TYPE: new FormControl(CONTACT_TYPE),
      PRIMARY_FLAG: new FormControl(null),
      PRIMARY_BY_PURPOSE: new FormControl(null),
      PHONE_LINE_TYPE: new FormControl(null),
      PHONE_COUNTRY_CODE: new FormControl(null),
      PHONE_AREA_CODE: new FormControl(null, [Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]),
      PHONE_NUMBER: new FormControl(null, [Validators.pattern(REGEX.PHONE_NUMBER)]),
      PHONE_EXTENSION: new FormControl(null),
      WEB_TYPE: new FormControl(null),
      URL: new FormControl(null),
      EMAIL_FORMAT: new FormControl(CONTACT_POINT_TYPE === 'EMAIL' ? 'EMAILHTML' : null),
      EMAIL_ADDRESS: new FormControl(null, [Validators.pattern(REGEX.EMAIL_ADDRESS)]),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required)
    });
  };


  /**
   * Build Customer Ref Form Object
   */
  initializeCustomerRef = (refType: string) => {
    return new FormGroup({
      REF_TYPE: new FormControl(refType),
      REF_NAME: new FormControl(null, [Validators.required,Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]),
      BANK_TRANSIT_NUM: new FormControl(null),
      BANK_ACCT_NUM: new FormControl(null),
      REF_ADDR1: new FormControl(null),
      REF_ADDR2: new FormControl(null),
      REF_CITY: new FormControl(null),
      REF_COUNTY: new FormControl(null),
      REF_STATE: new FormControl(null),
      REF_POSTAL_CODE: new FormControl(null),
      REF_POSTAL_PLUS4_CODE: new FormControl(null),
      CONTACT_PERSON: new FormControl(null),
      BANK_FAX_NUM: new FormControl(null),
      BANK_PH_NUM: new FormControl(null),
      PS_TR_COMP_NAME: new FormControl(null),
      PS_TR_FAX: new FormControl(null),
      PS_TR_PHONE: new FormControl(null),
      GAURANTOR_DATE: new FormControl(null),
      POSITION_NAME: new FormControl(null),
      REF_PHONE_NUM: new FormControl(null),
      REF_EMAIL: new FormControl(null),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required)
    });
  };


  /**
   * Build Customer Address Form Object
   */
  initializeCustomerAddress = (addressType: string, required?: boolean) => {
    return new FormGroup({
      ADDRESS_TYPE: new FormControl(addressType),
      ADDRESS_LINE1: new FormControl(null, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      ADDRESS_LINE2: new FormControl(null, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      CITY: new FormControl(null, [Validators.pattern(REGEX.CITY)]),
      COUNTY: new FormControl(null),
      COUNTY_FIPS: new FormControl(null),
      STATE: new FormControl(null),
      STATE_FIPS: new FormControl(null),
      POSTAL_CODE: new FormControl(null, [Validators.pattern(REGEX.ZIP_CODE)]),
      POSTAL_PLUS4_CODE: new FormControl(null),
      COUNTRY: new FormControl(this.currentCountry, [Validators.pattern(REGEX.ADDRESS_BETA)]),
      BILL_ADR_SAME_SHIP_ADR: new FormControl(null),
      NAME: new FormControl(null),
      POSITION: new FormControl(null),
      MYSQL_ORG_ID: new FormControl(this.mySQLOrgId, Validators.required)
    });
  };



  /**
   * Interlink FIPS Codes
   * @param index Index of Form Group Array
   * @param formArray Form Array
   * @param formControlName Source Form Control Name
   * @param assignToName Dest Form Control Name
   */
  public interlinkFIPS(index: number, formArray: string, formControlName: string, assignToName) {
    this.customerApplicationForm.controls[formArray]['controls'][index].controls[assignToName].value =
      this.customerApplicationForm.controls[formArray]['controls'][index].controls[formControlName].value.split('@')[1];
    this.customerApplicationForm.controls[formArray]['controls'][index].controls[formControlName].value =
      this.customerApplicationForm.controls[formArray]['controls'][index].controls[formControlName].value;
  }


  /**
   * Initialize Counties Look Up
   * @param country Country aka Division
   */
  private initializeStates = (country: string) => {
    this.lookupService.lookup('STATES', 'TRUE', country, undefined, undefined)
      .subscribe(res => {
        this.states = res;
      });
  };


  /**
   * Initialize Countries Look Up
   */
  public initializeCounties = (state: string, forType: string) => {


    this.lookupService.lookup('COUNTIES', 'TRUE', undefined, state, undefined)
      .subscribe(res => {

        switch (forType) {
          case 'applicant':
            this.countiesApplicant = res;
            break;
          case 'shipping':
            this.countiesShipping = res;
            break;
          case 'refOne':
            this.countiesRefOne = res;
            break;
          case 'refTwo':
            this.countiesRefTwo = res;
            break;
          case 'pg':
            this.countiesPG = res;
            break;
        }

      });
  };


  /**
   * Initialize Business Types Look Up
   */
  private initializeBusinessStructures = (orgId) => {
    // Defaulting to US aka 82
    this.lookupService.lookup('BUSINESS_TYPES', undefined, undefined, undefined, orgId)
      .subscribe(res => {
        this.businessStructures = res;
      });
  };


  /**
   * Enable or Disable Form Fields
   * @param condition enable/disable
   */
  private toggleForm = (condition: string) => {
    Object.keys(this.customerApplicationForm.controls).forEach(
      (controlName) => {
        this.customerApplicationForm.controls[controlName][condition]();
      });
  };


  /**
   * Page Scroll
   * @param el HTMLElement
   * @description Used in Fixed Side Menu
   */
  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
    // window.scrollTo(0,0);
    
  }

  
  /**
   * On Alert Close
   */
  onAlertClose() {
    this.showError = false;
    this.toggleForm('enable');
  }


  /**
   * Construct MJF File Object
   * @param event File Event
   */
  public onFileChangeBLC(event) {

    this.blcDocLabel = undefined;

    if (event.target.files.length > 1) {
      alert("filer limit error");
      this.blcFileErrorMessage = FILE_LIMIT_ERROR;
      this.docError = true;
      return;
    }

    if (event.target.files[0].size > FILE_SIZE_LIMIT) {
      this.blcFileErrorMessage = FILE_SIZE_ERROR;
      this.docError = true;
      return;
    }

    if (!FILE_FORMATS_ALLOWED.includes(event.target.files[0].type)) {
      this.blcFileErrorMessage = FILE_FORMAT_ERROR;
      this.docError = true;
      return;
    }

    this.blcFileErrorMessage = undefined;
    this.docError = false;
    this.blcDocLabel = event.target.files[0].name;
    this.blcDoc = event.target.files[0];
    const b64Reader: FileReader = new FileReader();
    b64Reader.readAsDataURL(this.blcDoc);
    b64Reader.onloadend = (e) => {
      this.blcDocB64 = b64Reader.result;
    };

  }

  /**
   * Construct Personal Guaranty File Object
   * @param event File Event
   */
  public onFileChangePG(event) {

    this.guarantorDocLabel = undefined;

    if (event.target.files.length > 1) {
      this.pgErrorMessage = FILE_LIMIT_ERROR;
      this.docError = true;
      return;
    }

    if (event.target.files[0].size > FILE_SIZE_LIMIT) {
      this.pgErrorMessage = FILE_SIZE_ERROR;
      this.docError = true;
      return;
    }

    if (!FILE_FORMATS_ALLOWED.includes(event.target.files[0].type)) {
      this.pgErrorMessage = FILE_FORMAT_ERROR;
      this.docError = true;
      return;
    }

    this.pgErrorMessage = undefined;
    this.docError = false;
    this.guarantorDocLabel = event.target.files[0].name;
    this.guarantorDoc = event.target.files[0];
    const b64Reader: FileReader = new FileReader();
    b64Reader.readAsDataURL(this.guarantorDoc);
    b64Reader.onloadend = (e) => {
      this.guarantorDocB64 = b64Reader.result;
    };

  }


  /**
   * Construct File Upload Object
   * @param body
   * @param base64Obj
   * @param docName
   * @param applicationId
   * @param prefix
   * @param file
   */
  public constructFileUploadObj(body, base64Obj, docName, applicationId, prefix, file) {

    const result = body;
    result.DOC_NAME = file.customName;
    result.LINK_TO_DOC = null;
    result.MYSQL_ORG_ID = this.mySQLOrgId;
    result.DOC_TYPE = prefix;
    result.APPLICATION_ID = applicationId;
 
    return JSON.stringify(result);
  }

  /**
   * Rename File
   * @param file File Object
   * @param applicationId Application Id
   * @param prefix Prefix
   */
  public static renameFile(file, applicationId, prefix) {

    const resultFile = file;
    let resultFileType = resultFile.type.split('/')[1];
    const doc = 'msword';
    const docx = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
    const xls = 'vnd.ms-excel';
    const xlsx = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if(resultFileType === doc){
      resultFileType = 'doc';
    } else if(resultFileType === docx){
      resultFileType = 'docx';
    } else if(resultFileType === xls){
      resultFileType = 'xls';
    } else if(resultFileType === xlsx){
      resultFileType = 'xlsx';
    }

    resultFile.customName = `${prefix}_${applicationId}.${resultFileType}`;

    return resultFile;

  }


  taxExemption(value:any){

    if(value === 'N'){

      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].clearValidators();
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].reset();


    }else{
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].setValue("");
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].setValidators([Validators.required]);

     
    }

  }
 
  /**
   * Submit Customer Application
   */
  public reviewApplication() {
    
    this.toggleForm('disable');
    this.validateBtnState = ClrLoadingState.LOADING;

    if( this.stateTaxFiles.length === 0 && this.enableMjf === 'yes' && this.taxDocsEnable === 'Y'){
      this.handleError("Error: Please upload State Tax Files.");
    } else {

      if(!this.blcDoc ){
        this.handleError("Error: Please upload Business License Certificate.");
      }else{
          
        let objDoc = { blc: this.blcDoc,
                    state: this.stateTaxFiles,
                    blcDocLabel: this.blcDocLabel,
                    stateTaxFilesLabels:this.stateTaxFilesLabels,
                    apContact: this.apRemoveControl,
                    countyapp: this.phonetype,
                    enableMjf: this.enableMjf,
                    enableShipping: this.toggleBillAddress,
                    requiredDocs: this.requiredDocuments,
                    enableTaxDocs: this.taxDocsEnable, 
                    mjfType: this.mjfType,
                    mjfval: this.mjfval,
                    taxExemptNote:this.taxExemptNote,
                    enableRequiredDocNote: this.enableRequiredDocNote

                    
        }

        this.messagesService.sendReviewData(this.customerApplicationForm);
        this.messagesService.sendDocData(objDoc);
        
        this.router.navigate(['/review']);

      // }
    
    }
  }
  }

  /**
   * Handle Error
   * @param err Error
   */
  private handleError(errMessage?) {
    this.errorMessage = errMessage;
    this.showError = true;
    console.log(`Error Submitting the form : ${errMessage}`);
    const top = document.getElementById('errorMessage');
    this.scroll(top);
    this.validateBtnState = ClrLoadingState.DEFAULT;
  }

  /**
   * Multi File Upload Handler
   * @param type
   * @param fileChangeEvent
   */
  public multiFileUpload(type: string, fileChangeEvent: any) {



    const files: Array<any> = fileChangeEvent.target.files;
    //this.stateTaxFilesLabels = [];

    if (ApplicationFormComponent.fileSanityCheck(files, (type === 'stateTaxFiles'))) {

      this.stateTaxFilesError = undefined;
      this.customerApplicationForm.controls['TAXABLE_ITEMS'].setValidators([Validators.required]);
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].setValidators([Validators.required]);
      this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].setValidators([Validators.required]);

      switch (this.stateTaxFilesLabels.length) {

        
        
        case 0:
          Array.from(files).forEach(file => {
            this.stateTaxFilesLabels.push(file.name);
            this.stateTaxFiles.push(file);
          });
          this.docError = false;
          break;
        case 1:
          if (files.length > 1) {
            this.stateTaxFilesLabels.pop();
            this.stateTaxFiles.pop();
            Array.from(files).forEach(file => {
              this.stateTaxFilesLabels.push(file.name);
              this.stateTaxFiles.push(file);
            });
            this.docError = false;
          } else {
            this.stateTaxFilesLabels.push(files[0].name);
            this.stateTaxFiles.push(files[0]);
            this.docError = false;
          }
          break;
        case 2:
          if (files.length > 1) {
            this.stateTaxFilesLabels.pop();
            this.stateTaxFiles.pop();
            Array.from(files).forEach(file => {
              this.stateTaxFilesLabels.push(file.name);
              this.stateTaxFiles.push(file);
            });
            this.docError = false;
          } else {
            this.stateTaxFilesLabels.push(files[0].name);
            this.stateTaxFiles.push(files[0]);
            this.docError = false;
          }
          break;

          case 3:

          if (files.length > 1) {
            this.stateTaxFilesLabels = [];
            this.stateTaxFiles = [];
            Array.from(files).forEach(file => {
              this.stateTaxFilesLabels.push(file.name);
              this.stateTaxFiles.push(file);
            });
            this.docError = false;
          } else {
            this.stateTaxFilesLabels.shift();
            this.stateTaxFilesLabels.push(files[0].name);
            this.stateTaxFiles.shift();
            this.stateTaxFiles.push(files[0]);
            this.docError = false;
          }
          break;

      }


    } else {

        Array.from(files).forEach(file => {
        if (!FILE_FORMATS_ALLOWED.includes(file.type)) { 
        this.stateTaxFilesError = FILE_FORMAT_ERROR;
        this.docError = true;
        return;
        } else {
        this.stateTaxFilesError = FILE_SIZE_ERROR;
        this.docError = true;
        }

        });




    }

  }


  resetCreditApplication(value: string): void {

    console.log('At reset credit', value);

    this.PROSPECT_ADDRESS = this.customerApplicationForm.get('PROSPECT_ADDRESS') as FormArray;
    this.PROSPECT_REFERENCE = this.customerApplicationForm.get('PROSPECT_REFERENCE') as FormArray;
    this.PROSPECT_CONTACT = this.customerApplicationForm.get('PROSPECT_CONTACT') as FormArray;


    if (value === 'N') {


      this.customerApplicationForm.controls['CUSTOMER_CREDIT_AUTHORIZED'].setValue('N');


      //CREDIT LIMIT  REMOVE VALIDATOR
      this.customerApplicationForm.controls['CREDIT_LIMIT_REQUESTED'].clearValidators();
      this.customerApplicationForm.controls['DNB_NUMBER'].clearValidators();

      this.customerApplicationForm.controls['CREDIT_LIMIT_REQUESTED'].reset();
      this.customerApplicationForm.controls['DNB_NUMBER'].reset();
      this.reviewState = 'N';
      this.apRemoveControl = 'Y';

    } else {
      //CREDIT LIMIT SET VALIDATOR

      this.customerApplicationForm.controls['CREDIT_LIMIT_REQUESTED'].setValidators([Validators.required, Validators.pattern(REGEX.USD)]);
      this.customerApplicationForm.controls['DNB_NUMBER'].setValidators([Validators.required]);
      this.apRemoveControl = 'N';
    }
  }


  buildMjf(state?:string, type?: string, val?:string){

    this.mjfType = type;
    this.mjfval = val;
    this.enableRequiredDocNote = (this.enableRequiredDocNote != 'Y') ? 'N' : 'Y';

    if(state && type === undefined){

      this.customerApplicationForm.controls['IS_CUST_TAX_EXEMPT'].setValue('Y');
      this.taxExemptNote = 'Y';
    }

    let taxExemptStates = ['AK', 'DE', 'MT', 'NH', 'OR' , 'AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'PR', 'VI'];

    this.applicantState = state;

    this.requiredDocuments= taxStates[state];

    if(this.enableRequiredDocNote=='Y'){
      this.taxDocsEnable = 'Y';
    }else if(docExemptStates.includes(state) || type === 'Exempt' && val === 'N'){
     
      this.taxDocsEnable = 'N';

    }else{
      this.taxDocsEnable = 'Y';


    }

   
    if(taxExemptStates.includes(state) || type === 'Exempt' && val === 'N'){
      this.enableMjf = 'no';
      this.enableRequiredDocNote = undefined;
      

      this.customerApplicationForm.controls['TAXABLE_ITEMS'].clearValidators();
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].clearValidators();
      this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].clearValidators();
      this.customerApplicationForm.controls['TIRE_DISPOSAL_FEE'].clearValidators();

      this.customerApplicationForm.controls['TAXABLE_ITEMS'].reset();
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].reset();
      this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].reset();
      this.customerApplicationForm.controls['TIRE_DISPOSAL_FEE'].reset();
      this.stateTaxFilesLabels = [];
      this.stateTaxFiles = [];


    }else{
      this.enableMjf = 'yes';
      this.customerApplicationForm.controls['TAXABLE_ITEMS'].setValidators([Validators.required]);
      this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].setValidators([Validators.required]);
      this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].setValidators([Validators.required]);

    }


  }

  openModal(){

    const invalids = [];
    const contactArray = [];

    if(this.customerApplicationForm.invalid){

      this.handleError('Please fill out the mandatory fields.To proceed,Please close this message');
      //PROSPECT INFO
      const prospectInfoControls = this.customerApplicationForm.controls;
      for (const name in prospectInfoControls) {
          if (prospectInfoControls[name].invalid) {
               invalids.push(name);
               prospectInfoControls[name].markAsTouched();
               if(name === "TYPE_OF_BUSINESS"){
                 this.typeOfBusiness = true;
               }
               if(name === "PROPERTY_DESCRIPTION"){
                 this.propertyDescriptionError = true;
               }
               if(name === "TAXABLE_ITEMS"){
                 this.taxableItemsError = true;
               }
          }
      }

      //PROSPECT ADDRESS
      let prospectAddressControls: any  = [];
      prospectAddressControls = this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'];
      prospectAddressControls.forEach((addressControl,index) => {
        for(const name in addressControl['controls']) {
          if(addressControl['controls'][name].invalid){
            addressControl['controls'][name].markAsTouched();
            this.validateDropdown(name, index);
          }
        }
      });

      // PROSPECT CONTACT

      let prospectContactControls: any  = [];
      prospectContactControls = this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'];
      prospectContactControls.forEach((contactControl,index) => {
      for(const name in contactControl['controls']) {
        if(contactControl['controls'][name].invalid){
            contactControl['controls'][name].markAsTouched();
            this.validateDropdown(name, index);
          }
        }
      });

      //  PROSPECT REFERENCE
    let prospectReferenceControls: any  = [];
      prospectReferenceControls = this.customerApplicationForm.controls['PROSPECT_REFERENCE']['controls'];
      prospectReferenceControls.forEach((referenceControl,index) => {
        for(const name in referenceControl['controls']) {
          if(referenceControl['controls'][name].invalid){
            referenceControl['controls'][name].markAsTouched();
            this.validateDropdown(name, index);
          }
        }
      });

      }else{
      this.reviewApplication();
    }
}

 validateDropdown(name:any, index:any){
  if(name=== "PHONE_LINE_TYPE" && index === 2){
    this.phoneLineType = true;
  } else if(name=== "PHONE_LINE_TYPE" && index === 8){
    this.phoneLineTypeTwo = true;
  } else if(name=== "STATE" && index === 0){
    this.addressState = true;
  } else if (name=== "COUNTY" && index === 0){
    this.addressCounty = true;
  } else if(name=== "STATE" && index === 1){
    this.billingAddressState = true;
  } else if(name=== "COUNTY" && index === 1){
    this.billingAddressCounty = true;
  } 
 }

  propertyDescription(val: any,state: any){

    this.enableRequiredDocNote = undefined;
    this.taxDocsEnable = undefined;
    this.stateTaxFilesLabels = [];
    this.stateTaxFiles = [];

    let propertyDescription: any;

    propertyDescription = this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].value;

    if(this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].valueChanges){
      if(propertyDescription === 'Direct Pay'){
          this.enableRequiredDocNote ='Y';
          this.taxDocsEnable = 'Y';
          this.requiredDocNote = 'Please Upload Direct Pay Permit issued by your State';
      } else if((propertyDescription === 'Resale') && (state ==='GA' || state ==='KY')){
          this.enableRequiredDocNote = 'Y';
          this.taxDocsEnable = 'N';
          this.requiredDocNote = 'No Additional Tax Documents are required to Upload.';
      } else if((propertyDescription !== 'Resale' || propertyDescription !== 'Direct Pay') && (state ==='GA')){
          this.enableRequiredDocNote = 'Y';
          this.taxDocsEnable = 'Y';
          this.requiredDocNote = 'Please Upload form ST-5'
      } else if((propertyDescription !== 'Resale' || propertyDescription !== 'Direct Pay') && (state ==='KY')){
          this.enableRequiredDocNote = 'Y';
          this.taxDocsEnable = 'Y';
          this.requiredDocNote = 'Please Upload Exemption Certificate'
      } else if((propertyDescription === 'Resale') && (state ==='WA')){
          this.enableRequiredDocNote = 'Y';
          this.taxDocsEnable = 'Y';
          this.requiredDocNote = 'Please Upload Reseller Permit'
      } else if((propertyDescription !== 'Resale' || propertyDescription !== 'Direct Pay') && (state ==='WA')){
          this.enableRequiredDocNote = 'Y';
          this.taxDocsEnable = 'N';
          this.requiredDocNote = 'No Additional Tax Documents are required to Upload';
      } else if(docExemptStates.includes(state)){
        this.enableRequiredDocNote = 'N';
          this.taxDocsEnable = 'N';
          this.requiredDocNote = 'No Additional Tax Documents are required to Upload';
      } else{
          this.enableRequiredDocNote ='N';
          this.taxDocsEnable = 'Y';
          this.requiredDocNote = this.requiredDocuments;
      }
      this.propertyDescriptionError = false;

      
    }
}

setToTwoDecimals(val: any){
  if(val){
    this.creditValue = parseFloat(val).toFixed(2);
  }
  return this.creditValue;
}

fixAnnualPurchaseValue(value: any){
  if(value){
    this.annualPurachaseValue = parseFloat(value).toFixed(2);
  } 
  return this.annualPurachaseValue;
}

taxableItems(val: any){
  if(this.customerApplicationForm.controls['TAXABLE_ITEMS'].valueChanges){
    this.taxableItemsError = false;
  }
}

  resetMjf(){

    this.stateTaxFilesLabels = [];
    this.stateTaxFiles = [];
    this.customerApplicationForm.controls['TAXABLE_ITEMS'].reset();
    this.customerApplicationForm.controls['TAX_EXEMPTION_NUMBER'].reset();
    this.customerApplicationForm.controls['PROPERTY_DESCRIPTION'].reset();
    this.customerApplicationForm.controls['TIRE_DISPOSAL_FEE'].reset();
    
  }

  resetApplicantAddress(value:any){

    if (value === 'Y') {

      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('STATE').clearValidators();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('COUNTY').clearValidators();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('CITY').clearValidators();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('ADDRESS_LINE1').clearValidators();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('POSTAL_CODE').clearValidators();

      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('STATE').reset();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('COUNTY').reset();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('CITY').reset();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('ADDRESS_LINE1').reset();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('ADDRESS_LINE2').reset();
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('POSTAL_CODE').reset();



    } else {
      //APPLICANT BILLING

      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('STATE').setValidators([Validators.required]);
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('COUNTY').setValidators([Validators.required,]);
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('CITY').setValidators([Validators.required, Validators.pattern(REGEX.CITY)]);
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('ADDRESS_LINE1').setValidators([Validators.required]);
      this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][1].get('POSTAL_CODE').setValidators([Validators.required,
      Validators.pattern(REGEX.ZIP_CODE)]);
    }

  }





  initializeValidators() {

    //APPLICANT VALIDATORS
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][0].get('PHONE_AREA_CODE').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][0].get('PHONE_NUMBER').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][1].get('EMAIL_ADDRESS').setValidators([Validators.required,
    Validators.pattern(REGEX.EMAIL_ADDRESS)]);

    //APPLICANT SHIPPING
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('STATE').setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('COUNTY').setValidators([Validators.required,]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('CITY').setValidators([Validators.required,Validators.pattern(REGEX.CITY)]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('ADDRESS_LINE1').setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('POSTAL_CODE').setValidators([Validators.required,
      Validators.pattern(REGEX.ZIP_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][0].get('BILL_ADR_SAME_SHIP_ADR').setValue('Y');
    



      

    //Adding Country code
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][0].controls['PHONE_COUNTRY_CODE'].setValue(this.phoneCountryCode);


    //OWNER VALIDATORS
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][2].get('PHONE_AREA_CODE').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][2].get('PHONE_NUMBER').setValidators([Validators.required,
    Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][2].get('PHONE_LINE_TYPE').setValidators([Validators.required]);



    //Adding Country code
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][2].controls['PHONE_COUNTRY_CODE'].setValue(this.phoneCountryCode);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][6].controls['PHONE_COUNTRY_CODE'].setValue(this.phoneCountryCode);


    //Adding Owner Principal Validators

    this.customerApplicationForm.controls['PROSPECT_REFERENCE']['controls'][0].controls['REF_NAME'].setValidators([Validators.required,Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['ADDRESS_LINE1'].setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['CITY'].setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['STATE'].setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['COUNTY'].setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['POSTAL_CODE'].setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['COUNTRY'].setValidators([Validators.required]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][4].get('PHONE_AREA_CODE').setValidators([Validators.required,
      Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][4].get('PHONE_NUMBER').setValidators([Validators.required,
      Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][5].get('EMAIL_ADDRESS').setValidators([Validators.required,
        Validators.pattern(REGEX.EMAIL_ADDRESS)]);

    // Adding AP Contact Validators

    this.customerApplicationForm.controls['PROSPECT_REFERENCE']['controls'][1].controls['REF_NAME'].setValidators([Validators.required,Validators.pattern(REGEX.FIRST_NAME_LAST_NAME)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][6].get('PHONE_AREA_CODE').setValidators([Validators.required,
      Validators.pattern(REGEX.PHONE_NUMBER_AREA_CODE)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][6].get('PHONE_NUMBER').setValidators([Validators.required,
      Validators.pattern(REGEX.PHONE_NUMBER)]);
    this.customerApplicationForm.controls['PROSPECT_CONTACT']['controls'][7].get('EMAIL_ADDRESS').setValidators([Validators.required,
      Validators.pattern(REGEX.EMAIL_ADDRESS)]);
  }
  }

